// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { EVENT_DETAILS } from '../../common/constant';
import { post } from '../../common/api';

export const actionEventDetails = createAsyncThunk('eventApp/actionEventDetails', async (params, thunkAPI) => {
    return await post(EVENT_DETAILS, params, thunkAPI)
})

export const eventRaceDetailsSlice = createSlice({
    name: 'eventApp',

    initialState: {
        //event details
        loadingEventDetails: true,
        eventDetails: null,

    },
    reducers: {
        //reset or delete public store data
        resetEventDetails: (state) => {
            state.eventDetails = null
            state.loadingEventDetails = false
        },
    },
    extraReducers: builder => {
        builder
            //event details
            .addCase(actionEventDetails.pending, (state) => {
                state.loadingEventDetails = true
            })
            .addCase(actionEventDetails.fulfilled, (state, action) => {
                state.eventDetails = action.payload
                state.loadingEventDetails = false
            })
            .addCase(actionEventDetails.rejected, (state) => {
                state.loadingEventDetails = false
            })
    }
})
export const { resetEventDetails } = eventRaceDetailsSlice.actions

export default eventRaceDetailsSlice.reducer